import React from 'react';

import {cx} from '../util';

export const BadgeColors = {
  INDIGO: 'indigo',
  GREEN: 'green',
  YELLOW: 'yellow',
  RED: 'red',
  GRAY: 'gray',
};

export const DifficultyToBadge = {
  Easy: {color: BadgeColors.GREEN, text: 'Easy'},
  Medium: {color: BadgeColors.YELLOW, text: 'Medium'},
  Hard: {color: BadgeColors.RED, text: 'Hard'},
};

export const Badge = ({
  children, className, color = BadgeColors.INDIGO, size,
}) => (
  <span
    className={cx('font-semibold inline-block rounded-full', size === 'small' ? 'text-[11px] py-0.5 px-1.5' : 'text-xs py-1 px-2', {
      'bg-indigo-100 text-indigo-600': color === BadgeColors.INDIGO,
      'bg-green-100 text-green-800': color === BadgeColors.GREEN,
      'bg-yellow-100 text-yellow-800': color === BadgeColors.YELLOW,
      'bg-red-100 text-red-800': color === BadgeColors.RED,
      'bg-gray-100 text-gray-800': color === BadgeColors.GRAY,
    }, className)}
  >
    {children}
  </span>
);
